module.exports = __webpack_public_path__ + "img/tg.683f9180.png";